import { useMutation } from '@tanstack/react-query';
import { createGoalTemplate } from 'shared/services/backend-api';
import { CreateGoalTemplate } from 'shared/types/create-goal-template';

export const useCreateGoalTemplateMutation = () =>
  useMutation({
    mutationFn: async (template: CreateGoalTemplate) =>
      createGoalTemplate(template),
  });
